import React, { useEffect, useRef } from 'react';

import { TableViews } from './constants';

interface TableLayoutProps {
  headers: JSX.Element[];
  rows: JSX.Element[];
  isHidden: boolean;
  viewName: TableViews;
}

const TableLayout = ({ headers, rows, isHidden, viewName }: TableLayoutProps): JSX.Element => {
  const table = useRef(null);

  useEffect(() => {
    if (!headers || !rows || isHidden) return;

    const currentDataTable = global.$(table.current).DataTable({
      paging: false, // removes pagination
      info: false, // removes page counts
      ordering: true, // defaults the order to rank
      order: [[0, 'asc']], // sets dafault sort to be by company name
      dom: 'lrtip', // removes standard search box
      responsive: {
        details: true,
      },
    });

    return () => {
      currentDataTable?.destroy();
    };
  }, [headers, rows, isHidden]);

  return (
    <table
      className={`stocktable display no-wrap table-striped !mt-40 ${
        isHidden ? '!hidden' : 'table'
      } is-${viewName.toLowerCase()}`}
      ref={table}
    >
      <thead>
        <tr>{headers}</tr>
      </thead>
      <tbody>{rows}</tbody>
    </table>
  );
};

export default TableLayout;
